import React, { useState } from 'react';
import { CampaignData } from '../utils/mockData';
import { TrendingUp, TrendingDown, ChevronRight } from 'lucide-react';
import { LeadDetailsModal } from './LeadDetailsModal';
interface CampaignTableProps {
  campaigns: CampaignData[];
}
export function CampaignTable({
  campaigns
}: CampaignTableProps) {
  const [selectedCampaign, setSelectedCampaign] = useState<CampaignData | null>(null);
  return <>
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-1">
        <div className="p-6 border-b border-slate-200 flex justify-between items-center" data-id="element-2">
          <h3 className="text-lg font-semibold text-slate-900" data-id="element-3">
            Campaign Performance
          </h3>
          <span className="text-sm text-slate-500" data-id="element-4">Last 30 Days</span>
        </div>

        <div className="overflow-x-auto" data-id="element-5">
          <table className="w-full text-left text-sm" data-id="element-6">
            <thead className="bg-slate-50 text-slate-500 font-medium" data-id="element-7">
              <tr data-id="element-8">
                <th className="px-6 py-4" data-id="element-9">Campaign Name</th>
                <th className="px-6 py-4 text-right" data-id="element-10">Leads</th>
                <th className="px-6 py-4 text-right" data-id="element-11">Credit Pulls</th>
                <th className="px-6 py-4 text-right" data-id="element-12">Fundings</th>
                <th className="px-6 py-4 text-right" data-id="element-13">Spend</th>
                <th className="px-6 py-4 text-right" data-id="element-14">ROI</th>
                <th className="px-6 py-4 w-10" data-id="element-15"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-16">
              {campaigns.map(campaign => <tr key={campaign.id} onClick={() => setSelectedCampaign(campaign)} className="hover:bg-blue-50/50 transition-colors cursor-pointer group" data-id="element-17">
                  <td className="px-6 py-4 font-medium text-slate-900 group-hover:text-blue-700" data-id="element-18">
                    {campaign.name}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-19">
                    {campaign.leads.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-20">
                    {campaign.creditPulls.toLocaleString()}
                    <span className="text-xs text-slate-400 block" data-id="element-21">
                      {Math.round(campaign.creditPulls / campaign.leads * 100)}
                      % conv
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right font-medium text-slate-900" data-id="element-22">
                    {campaign.fundings}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-23">
                    ${campaign.spend.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-24">
                    <div className={`flex items-center justify-end gap-1 font-medium ${parseInt(campaign.roi) > 200 ? 'text-emerald-600' : parseInt(campaign.roi) > 100 ? 'text-blue-600' : 'text-amber-600'}`} data-id="element-25">
                      {parseInt(campaign.roi) > 100 ? <TrendingUp size={14} data-id="element-26" /> : <TrendingDown size={14} data-id="element-27" />}
                      {campaign.roi}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right text-slate-400" data-id="element-28">
                    <ChevronRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-29" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {selectedCampaign && <LeadDetailsModal campaign={selectedCampaign} isOpen={!!selectedCampaign} onClose={() => setSelectedCampaign(null)} data-id="element-30" />}
    </>;
}